<template>
  <TTitle size="2xl" :responsive="false">{{
    t('views.cottage-contact-deal.resume.details.title')
  }}</TTitle>

  <div class="mb-4">
    <div class="flex justify-between">
      <div>
        <TText size="base" classes="m-0" :variant="'semibold'">{{
          item.deal.rentUnitName
        }}</TText>
        <TText size="sm" classes="mb-0">{{
          t(
            'views.cottage-contact-deal.resume.details.people',
            item.deal.people,
          )
        }}</TText>
      </div>

      <div>
        <TText size="lg" classes="m-0 text-end">
          {{ toEuro(item.deal.total.amount) }}</TText
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CottageContactDealPage } from '~~/modules/views/cottage-contact-deal/entities/CottageContactDealPage'

type itemType = {
  deal: Pick<
    CottageContactDealPage['deal'],
    'total' | 'rentUnitName' | 'people'
  >
}

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
